/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/ordering-node',['require','jquery','underscore','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var OrderingNode = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    _nodeHolderMC: null,
    _revealHolderMC: null,

    id: null,
    _type: null,

    _itemHolderMC: null,
    _currentItem: null,

    _positionIndexArr: [],
    itemArr: [],

    _nodeRect: null,
    _nodeWidth: -1,

    _revealText: null,

    layout: 0,

    offset: -1,
    _origItemArr: null,

    // GRID OPTIONS
    rowSize: 100,
    colSize: 100,
    gutter: 7, // Spacing between tiles
    numTiles: 25, // Number of tiles to initially populate the grid with
    fixedSize: false, // When true, each tile's colspan will be fixed to 1
    oneColumn: false, // When true, grid will only have 1 column and tiles have fixed colspan of 1
    threshold: '50%', // This is amount of overlap between tiles needed to detect a collision

    // Live node list of tiles
    tiles: [],//$list[0].getElementsByClassName('tile');
    label: 1,
    zIndex: 1000,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(__ele)
    {
      this._nodeHolderMC = __ele;
    },

    init: function($arr)
    {
      //console.log('init node', $arr);
      this.initItems($arr);
    },

    enableNode: function()
    {
      var $orderItem;
      for (var $key in this.itemArr)
      {
        $orderItem = this.itemArr[$key];
        //$orderItem.enable();
      }
    },

    disableNode: function()
    {
      var $orderItem;
      for (var $key in this.itemArr)
      {
        $orderItem = this.itemArr[$key];
        //$orderItem.disable();
      }
    },

    resetOrderingNode: function()
    {
      var $orderItem;
      //var $xNum;
      //var $yNum;

      //this._itemHolderMC.removeEventListener(Event.ENTER_FRAME, onFrameHandler);

      this.itemArr = this._origItemArr.concat();
      this._currentItem = this.itemArr[0];

      for (var $i = 0; $i < this.itemArr.length; $i++)
      {
        $orderItem = this.itemArr[$i];
        //trace('$orderItem.asset_mc.index = '+$orderItem.asset_mc.index);
        $orderItem.data().completed = false;
        //$orderItem.unlock();

        if (this.layout === 1)
        {
          $orderItem.css('top', this.offset * $i);
        }
        else
        {
          //$orderItem.asset.x = this.offset * $i;
        }
      }

      //this._itemHolderMC.addEventListener(Event.ENTER_FRAME, onFrameHandler);
    },

    checkComplete: function()
    {
      var $allComplete = true;
      var $orderItem;

      //console.log('check complete', this, this.itemArr);
      for (var $i = 0; $i < this.itemArr.length; $i++)// $orderItem in itemArr)
      {
        $orderItem = this.itemArr[$i];
        //console.log('item', $orderItem, $orderItem.data());
        if ($orderItem.data().accuracy === $i)
        {
          //console.log('correct');
          $orderItem.data().completed = true;//complete();
          Draggable.get($orderItem).disable();
        }
        else
        {
          //console.log('incorrect');
          //$orderItem.incomplete();
          $allComplete = false;
        }
      }

      return $allComplete;
    },

    showAnswer: function()
    {
      //itemArr.sortOn('accuracy', Array.NUMERIC);
      this.itemArr = _.sortBy(this.itemArr, '[0].accuracy');
      /*if (_revealHolderMC && _revealText)
      {
        var $rMC:MovieClip = _revealHolderMC['r' + this.id] as MovieClip;
        if ($rMC)
        {
          $rMC.txt.htmlText = _revealText;
        }
      }*/
    },

    /////////////////////////////////////////
    /////////////////////////////////////////

    initItems: function($arr)
    {
      var $orderItem;
      var $prevItem;
      this.itemArr = [];

      this._itemHolderMC = this._nodeHolderMC.find('[data-mc="n' + this.id + '"]');
      if (this._itemHolderMC.length === 0)
      {
        this._itemHolderMC = $('<div>');//new MovieClip();
        this._itemHolderMC.attr('data-mc', 'n' + this.id).addClass('ordering-node');
        this._nodeHolderMC.append(this._itemHolderMC);
      }

      var $btn;
      for (var $i = 0; $i < $arr.length; $i++)
      {
        $btn = $arr[$i];
        //console.log('order btn', $btn);

        //$ref = $btn.classRef ? $btn.classRef:"SortItem";
        //$class = getDefinitionByName($ref);
        $orderItem = $('<div>').addClass('order-item box-background');//new OrderingItem(new $class());
        $orderItem.html(_.get($btn.text, '[0][0].text'));
        $orderItem.data().btn = $btn;
        //console.log('order item', $orderItem);
        //trace("$btn.id = "+$btn.id);
        //$orderItem.init($btn);
        $orderItem.data().index = $i;
        $orderItem.data().accuracy = parseInt($btn.order);// = $i;
        $orderItem[0].accuracy = parseInt($btn.order);
        this._itemHolderMC.append($orderItem);

        if ($prevItem)
        {
          if (this.offset !== -1)
          {
            $orderItem.css('top', this.offset * $i);
          }
          else
          {
            //console.log('prevtop', $prevItem.position().top + $prevItem.height() + 30);
            $orderItem.css('top', $prevItem.position().top + $prevItem.height() + 30);
          }
        }

        this._positionIndexArr.push($orderItem.position());//{ x:$orderItem.asset.x, y:$orderItem.asset.y } );
        this.itemArr.push($orderItem);
        $prevItem = $orderItem;
      }

      this._origItemArr = this.itemArr.concat();

      this.registerItems();
      this.enableNode();
    },

    shuffleItems: function()
    {
      this.itemArr = _.shuffle(this.itemArr);
    },

    onDrag: function($e)
    {
      //this.updatePositions();
    },

    updatePositions: function()
    {
      var $key;
      var $orderItem;
      var $y;
      //var $x;
      var $completeArr = [];
      var $yArr = [];

      if (this._currentItem)
      {
        //var $tmpArr = [];
        ////console.log('update pos');
        for ($key in this.itemArr)
        {
          $orderItem = this.itemArr[$key];
          $orderItem[0].y = $orderItem.position().top;
          if ($orderItem.data().completed)
          {
            $completeArr.push($orderItem);
          }
          else
          {
            $yArr.push($orderItem);
          }
        }

        //$yArr.sortOn('y', Array.NUMERIC);
        $yArr = _.sortBy($yArr, '[0].y');

        $completeArr = _.sortBy($completeArr, 'order');//, Array.NUMERIC);

        for ($key in $completeArr)
        {
          $orderItem = $completeArr[$key];
          $yArr.splice($orderItem.data().accuracy, 0, $orderItem);
        }
        this.itemArr = $yArr;
      }
      ////console.log('items', this.itemArr, this._positionIndexArr);
      for (var $i = 0; $i < this.itemArr.length; $i++)// $orderItem in itemArr)
      {
        $orderItem = this.itemArr[$i];
        if (this.layout === 1)
        {
          $y = this._positionIndexArr[$i].top;
          if ($orderItem !== this._currentItem)
          {
            ////console.log('check item', $y, $orderItem.position().top, $orderItem.position().top + (-($orderItem.position().top - $y) / 4));
            $orderItem.css('top', $orderItem.position().top + (-($orderItem.position().top - $y) / 4));
          }
        }
        else
        {
          // $x = _positionIndexArr[$i].x;
          // if ($orderItem !== _currentItem)
          // {
          //   $orderItem.asset.x = $orderItem.asset.x + -($orderItem.asset.x - $x) / 4;
          // }
        }
      }
    },

    registerItems: function()
    {
      var $orderItem;
      for (var $key in this.itemArr)
      {
        $orderItem = this.itemArr[$key];
        Draggable.create($orderItem, {
          //onDrag: $.proxy(this.updatePositions, this, $orderItem),
          onPress: $.proxy(this.startItemDrag, this, $orderItem),
          onRelease: $.proxy(this.stopItemDrag, this, $orderItem),
          bounds: this._nodeHolderMC,
          zIndexBoost: true,
          type: 'top'
        });

        //$orderItem.mc.addEventListener(MouseEvent.MOUSE_DOWN, onItemDownHandler);
      }
      this.orderInt = setInterval($.proxy(this.updatePositions, this), 50);
    },

    onPress: function($e)
    {
      /*//startItemDrag($e.currentTarget.wrapper as OrderingItem);
      lastX = this.x;
      tile.isDragging = true;
      tile.lastIndex = tile.index;

      TweenLite.to(element, 0.2, {
        autoAlpha: 0.75,
        boxShadow: shadow2,
        scale: 0.95,
        zIndex: '+=1000'
      });*/
    },

    onRelease: function($e)
    {
      //stopItemDrag(_currentItem);
    },

    startItemDrag: function($item)
    {
      this._currentItem = $item;
      // _itemHolderMC.addChild(_currentItem.asset);
      // _currentItem.asset.startDrag(false, _nodeRect);
      // _itemHolderMC.stage.addEventListener(MouseEvent.MOUSE_UP, onItemUpHandler);
    },

    stopItemDrag: function($item)
    {
      // _itemHolderMC.stage.removeEventListener(MouseEvent.MOUSE_UP, onItemUpHandler);
      // MovieClip(_currentItem.asset).stopDrag();
      this._currentItem = null;
    },

    onBeforeDestroy: function()
    {
      var $orderItem;

      clearInterval(this.orderInt);
      for (var key in this.itemArr)
      {
        $orderItem = this.itemArr[key];
        //$orderItem.mc.off('click');//MouseEvent.MOUSE_DOWN, onItemDownHandler);
        // if ($orderItem.mc.stage)
        // {
        //   $orderItem.mc.stage.removeEventListener(MouseEvent.MOUSE_UP, onItemUpHandler);
        // }
      }
      //_itemHolderMC.removeEventListener(Event.ENTER_FRAME, onFrameHandler);
      this.itemArr = [];
    }

  /*****************************************************************************************************************///}

  });

  return OrderingNode;

});
/* jshint ignore:start */
/*  //All code created by Blake Bowen
//Forked from: http://codepen.io/osublake/pen/RNLdpz/

// GRID OPTIONS
var rowSize = 100;
var colSize = 100;
var gutter = 7; // Spacing between tiles
var numTiles = 25; // Number of tiles to initially populate the grid with
var fixedSize = false; // When true, each tile's colspan will be fixed to 1
var oneColumn = false; // When true, grid will only have 1 column and tiles have fixed colspan of 1
var threshold = '50%'; // This is amount of overlap between tiles needed to detect a collision

var $add = $('#add');
var $list = $('#list');
var $mode = $('input[name='layout']');

// Live node list of tiles
var tiles = $list[0].getElementsByClassName('tile');
var label = 1;
var zIndex = 1000;

var startWidth = '100%';
var startSize = colSize;
var singleWidth = colSize * 3;

var colCount = null;
var rowCount = null;
var gutterStep = null;

var shadow1 = '0 1px 3px  0 rgba(0, 0, 0, 0.5), 0 1px 2px 0 rgba(0, 0, 0, 0.6)';
var shadow2 = '0 6px 10px 0 rgba(0, 0, 0, 0.3), 0 2px 2px 0 rgba(0, 0, 0, 0.2)';

$(window).resize(resize);
$add.click(createTile);
$mode.change(init);

init();

// ========================================================================
//  INIT
// ========================================================================
function init() {

  var width = startWidth;

  // This value is defined when this function
  // is fired by a radio button change event
  switch (this.value) {

    case 'mixed':
      fixedSize = false;
      oneColumn = false;
      colSize = startSize;
      break;

    case 'fixed':
      fixedSize = true;
      oneColumn = false;
      colSize = startSize;
      break;

    case 'column':
      fixedSize = false;
      oneColumn = true;
      width = singleWidth;
      colSize = singleWidth;
      break;
  }

  $('.tile').remove();

  TweenLite.to($list, 0.2, {
    width: width
  });
  TweenLite.delayedCall(0.25, populateBoard);

  function populateBoard() {

    label = 1;
    resize();

    for (var i = 0; i < numTiles; i++) {
      createTile();
    }
  }
}

// ========================================================================
//  RESIZE
// ========================================================================
function resize() {

  colCount = oneColumn ? 1 : Math.floor($list.outerWidth() / (colSize + gutter));
  gutterStep = colCount === 1 ? gutter : (gutter * (colCount - 1) / colCount);
  rowCount = 0;

  layoutInvalidated();
}

// ========================================================================
//  CHANGE POSITION
// ========================================================================
function changePosition(from, to, rowToUpdate) {

  var $tiles = $('.tile');
  var insert = from > to ? 'insertBefore' : 'insertAfter';

  // Change DOM positions
  $tiles.eq(from)[insert]($tiles.eq(to));

  layoutInvalidated(rowToUpdate);
}

// ========================================================================
//  CREATE TILE
// ========================================================================
function createTile() {

  var colspan = fixedSize || oneColumn ? 1 : Math.floor(Math.random() * 2) + 1;
  var element = $('<div></div>').addClass('tile').html(label++);
  var lastX = 0;

  Draggable.create(element, {
    onDrag: onDrag,
    onPress: onPress,
    onRelease: onRelease,
    zIndexBoost: false
  });

  // NOTE: Leave rowspan set to 1 because this demo
  // doesn't calculate different row heights
  var tile = {
    col: null,
    colspan: colspan,
    element: element,
    height: 0,
    inBounds: true,
    index: null,
    isDragging: false,
    lastIndex: null,
    newTile: true,
    positioned: false,
    row: null,
    rowspan: 1,
    width: 0,
    x: 0,
    y: 0
  };

  // Add tile properties to our element for quick lookup
  element[0].tile = tile;

  $list.append(element);
  layoutInvalidated();

  function onPress() {

    lastX = this.x;
    tile.isDragging = true;
    tile.lastIndex = tile.index;

    TweenLite.to(element, 0.2, {
      autoAlpha: 0.75,
      boxShadow: shadow2,
      scale: 0.95,
      zIndex: '+=1000'
    });
  }

  function onDrag() {

    // Move to end of list if not in bounds
    if (!this.hitTest($list, 0)) {
      tile.inBounds = false;
      changePosition(tile.index, tiles.length - 1);
      return;
    }

    tile.inBounds = true;

    for (var i = 0; i < tiles.length; i++) {

      // Row to update is used for a partial layout update
      // Shift left/right checks if the tile is being dragged
      // towards the the tile it is testing
      var testTile = tiles[i].tile;
      var onSameRow = (tile.row === testTile.row);
      var rowToUpdate = onSameRow ? tile.row : -1;
      var shiftLeft = onSameRow ? (this.x < lastX && tile.index > i) : true;
      var shiftRight = onSameRow ? (this.x > lastX && tile.index < i) : true;
      var validMove = (testTile.positioned && (shiftLeft || shiftRight));

      if (this.hitTest(tiles[i], threshold) && validMove) {
        changePosition(tile.index, i, rowToUpdate);
        break;
      }
    }

    lastX = this.x;
  }

  function onRelease() {

    // Move tile back to last position if released out of bounds
    this.hitTest($list, 0) ?
      layoutInvalidated() :
      changePosition(tile.index, tile.lastIndex);

    TweenLite.to(element, 0.2, {
      autoAlpha: 1,
      boxShadow: shadow1,
      scale: 1,
      x: tile.x,
      y: tile.y,
      zIndex: ++zIndex
    });

    tile.isDragging = false;
  }
}

// ========================================================================
//  LAYOUT INVALIDATED
// ========================================================================
function layoutInvalidated(rowToUpdate) {

  var timeline = new TimelineMax();
  var partialLayout = (rowToUpdate > -1);

  var height = 0;
  var col = 0;
  var row = 0;
  var time = 0.35;

  $('.tile').each(function(index, element) {

    var tile = this.tile;
    var oldRow = tile.row;
    var oldCol = tile.col;
    var newTile = tile.newTile;

    // PARTIAL LAYOUT: This condition can only occur while a tile is being
    // dragged. The purpose of this is to only swap positions within a row,
    // which will prevent a tile from jumping to another row if a space
    // is available. Without this, a large tile in column 0 may appear
    // to be stuck if hit by a smaller tile, and if there is space in the
    // row above for the smaller tile. When the user stops dragging the
    // tile, a full layout update will happen, allowing tiles to move to
    // available spaces in rows above them.
    if (partialLayout) {
      row = tile.row;
      if (tile.row !== rowToUpdate) return;
    }

    // Update trackers when colCount is exceeded
    if (col + tile.colspan > colCount) {
      col = 0;
      row++;
    }

    $.extend(tile, {
      col: col,
      row: row,
      index: index,
      x: col * gutterStep + (col * colSize),
      y: row * gutterStep + (row * rowSize),
      width: tile.colspan * colSize + ((tile.colspan - 1) * gutterStep),
      height: tile.rowspan * rowSize
    });

    col += tile.colspan;

    // If the tile being dragged is in bounds, set a new
    // last index in case it goes out of bounds
    if (tile.isDragging && tile.inBounds) {
      tile.lastIndex = index;
    }

    if (newTile) {

      // Clear the new tile flag
      tile.newTile = false;

      var from = {
        autoAlpha: 0,
        boxShadow: shadow1,
        height: tile.height,
        scale: 0,
        width: tile.width
      };

      var to = {
        autoAlpha: 1,
        scale: 1,
        zIndex: zIndex
      }

      timeline.fromTo(element, time, from, to, 'reflow');
    }

    // Don't animate the tile that is being dragged and
    // only animate the tiles that have changes
    if (!tile.isDragging && (oldRow !== tile.row || oldCol !== tile.col)) {

      var duration = newTile ? 0 : time;

      // Boost the z-index for tiles that will travel over
      // another tile due to a row change
      if (oldRow !== tile.row) {
        timeline.set(element, {
          zIndex: ++zIndex
        }, 'reflow');
      }

      timeline.to(element, duration, {
        x: tile.x,
        y: tile.y,
        onComplete: function() {
          tile.positioned = true;
        },
        onStart: function() {
          tile.positioned = false;
        }
      }, 'reflow');
    }
  });

  // If the row count has changed, change the height of the container
  if (row !== rowCount) {
    rowCount = row;
    height = rowCount * gutterStep + (++row * rowSize);
    timeline.to($list, 0.2, {
      height: height
    }, 'reflow');
  }
} */
/* jshint ignore:end */
;
